import React from 'react';
import { type IConfiguration } from '@enuan/chat__utils';

export const configurationContext: React.Context<IConfiguration> =
	React.createContext<IConfiguration>({} as IConfiguration);
